import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CabecalhoPadrao from "../components/CabecalhoPadrao/CabecalhoPadrao";
import DropdownPadrao from "../components/DropdownPadrao/DropdownPadrao";
import FiltroPadrao from "../components/FiltroPadrao/FiltroPadrao";
import InputPadrao from "../components/InputPadrao/InputPadrao";
import TabelaPadrao from "../components/TabelaPadrao/TabelaPadrao";
import { useEmpresa, usePlano } from "../hooks/DropdownHooks";
import FiltroURLWrapper from "../hooks/FiltroUrlHook";
import api from '../services/api';
import FiltroUtils from '../utils/FiltroUtils';
import { APP_ROUTES, getEditarPath } from "../services/app_routes";
import { isSuperAdmin, PERMISSOES, validarPermissoes } from "../utils/PermissaoUtils";
import PAGINATION from "../utils/PaginacaoUtils";
import Carregamento from "../components/Carregamento/Carregamento";
import { BREAKPOINTS_PADRAO, OPCOES_SITUACAO, COLUNA_SITUACAO, definirColunasFixas, criarColuna } from "../utils/ListagemUtils";
import Mensagens from "../utils/MensagemUtils";
import NotificacaoUtils from "../utils/NotificacaoUtils";
import ListagemInfoLicenca from "../components/ListagemInfoLicenca/ListagemInfoLicenca";
import CsvUtils from '../utils/CsvUtils';
import { TipoRelatorio } from '../utils/RelatorioUtils';

const ListagemCliente = () => {
    const navigate = useNavigate();
    const [clientes, setClientes] = useState([]);
    const [totalClientes, setTotalClientes] = useState(0);
    const [carregando, setCarregando] = useState(false);
    const [buscaInicial, setBuscaInicial] = useState(true);
    
    const filtrarRef = useRef(null);
    const currentPageRef = useRef(PAGINATION.DEFAULT_FIRST_PAGE);
    const { itens: empresas, carregando: carregandoEmpresas } = useEmpresa();
    const { itens: planos, carregando: carregandoPlanos } = usePlano(false);
    
    const carregamentoGeral = () => carregando || carregandoEmpresas || carregandoPlanos;
    
    const filtrosPadrao = {
        razaoSocial: "",
        documento: "",
        idEmpresa: "", // Alterado de 'empresa' para 'idEmpresa' para corresponder ao esperado pelo backend
        situacaoCadastro: "",
        idPlano: "",
        unidade: "",
    };
    
    const colunas = [
      criarColuna(Mensagens.CLIENTE.LISTAGEM.RAZAO_SOCIAL, 'clienteDTO.razaoSocial'),
      criarColuna(Mensagens.CLIENTE.LISTAGEM.DOCUMENTO, 'clienteDTO.documento'),
      criarColuna(Mensagens.CLIENTE.LISTAGEM.COLUNA_EMPRESA, 'clienteDTO.empresaDTO.razaoSocial'),
      COLUNA_SITUACAO(obj => obj.clienteDTO?.situacaoCadastro),
      criarColuna(Mensagens.CLIENTE.LISTAGEM.LICENCAS_ATIVAS, 'licencasAtivas'),
      criarColuna(Mensagens.CLIENTE.LISTAGEM.LICENCAS_TOTAIS, 'licencasTotais'),
    ];
    
    //define quais colunas aparecem ou não conforme a permissão
    const colunasPermissao = {
      'clienteDTO.empresaDTO': isSuperAdmin(),
    };
    
    const colunasFixas = definirColunasFixas();
    
    useEffect(() => {
        // Garantir que a busca inicial seja feita com situacaoCadastro=ATIVO
        if (filtrarRef.current) filtrarRef.current(0); // Forçar página 0 para busca inicial
    }, []); 

    const handleEditarLicenca = (licenca, cliente) => {
      if (cliente.clienteDTO.id && licenca.id) {
        navigate(
          getEditarPath(APP_ROUTES.CLIENTE_GERAL_EDITAR, cliente.clienteDTO.id) +
          `?licencaId=${licenca.id}`
        );
      }
    };

    const gerarCsvCliente = async (filtros) => {
      let clientesCsv = [];

      const filtrosParaCsv = filtros ? FiltroUtils.applyPageFilter(0, PAGINATION.DEFAULT_PAGE_SIZE, filtros) : "";

      try {
        const response = await api.post(`/relatorio_${filtrosParaCsv}`, {
          tipoRelatorio: TipoRelatorio.CLIENTE,
          colunasSelecionadas: [],
        });

        const apiResponse = response.data;

        if (response.success) {
          clientesCsv = apiResponse.linhas;
          const colunasParaGerarCsvCliente = apiResponse.colunas.map(coluna => coluna.titulo);

          if (apiResponse.linhas.length === 0) {
            NotificacaoUtils.aviso("Nenhum dado encontrado para gerar o CSV.");
            return;
          }

          CsvUtils.gerarCsv(clientesCsv, colunasParaGerarCsvCliente, "relatorio_clientes.csv");
          NotificacaoUtils.sucesso("CSV gerado com sucesso!");
        } else {
          NotificacaoUtils.aviso(response.message);
        }
      } catch (error) {
        console.error("Erro ao gerar CSV:", error);
        NotificacaoUtils.erro("Erro ao gerar CSV.");
      }
    };

    const gerarCsvSistema = async (filtros) => {
      let clientesCsv = [];

      const filtrosParaCsv = filtros ? FiltroUtils.applyPageFilter(0, PAGINATION.DEFAULT_PAGE_SIZE, filtros) : "";

      try {
        const response = await api.post(`/relatorio_${filtrosParaCsv}`, {
          tipoRelatorio: TipoRelatorio.SISTEMA,
          colunasSelecionadas: [],
        });

        const apiResponse = response.data;

        if (response.success) {
          clientesCsv = apiResponse.linhas;
          const colunasParaGerarCsvCliente = apiResponse.colunas.map(coluna => coluna.titulo);

          if (apiResponse.linhas.length === 0) {
            NotificacaoUtils.aviso("Nenhum dado encontrado para gerar o CSV.");
            return;
          }

          CsvUtils.gerarCsv(clientesCsv, colunasParaGerarCsvCliente, "relatorio_sistemas.csv");
          NotificacaoUtils.sucesso("CSV gerado com sucesso!");
        } else {
          NotificacaoUtils.aviso(response.message);
        }
      } catch (error) {
        console.error("Erro ao gerar CSV:", error);
        NotificacaoUtils.erro("Erro ao gerar CSV.");
      }
    };

    return (
      <FiltroURLWrapper
        defaultFilters={filtrosPadrao}
        defaultPage={PAGINATION.DEFAULT_FIRST_PAGE}
        defaultSize={PAGINATION.DEFAULT_PAGE_SIZE}
        basePath={'/cliente/visualizar'}
      >
        {({
          currentPage,
          pageSize,
          filtros,
          setFiltros,
          aplicarFiltros,
          limparFiltros,
          proximaPagina,
          paginaAnterior,
          irParaPagina,
        }) => {
          
          const fetchClientes = async queryString => {
            setCarregando(true);
            try {
              const apiResponse = await api.get('/cliente_/geral' + queryString);
              if (apiResponse.success) {
                const data = apiResponse.data;
                const clientes = data.content;
                const page = data.page;
                setClientes(clientes);
                setTotalClientes(page.totalElements);
              } else {
                NotificacaoUtils.erro(Mensagens.ERRO.ERRO_BUSCAR_DADOS);
                setClientes([]);
                setTotalClientes(0);
              }
            } catch (error) {
              console.error('Erro ao buscar clientes:', error);
              NotificacaoUtils.erro(Mensagens.ERRO.ERRO_BUSCAR_DADOS);
              setClientes([]);
              setTotalClientes(0);
            } finally {
              setCarregando(false);
            }
          };

          // filtrar agora aceita page como argumento
          const filtrar = async (page = 0) => {
            // Se for a busca inicial (primeira execução) e não há filtro de situação definido, aplicar ATIVO
            if (buscaInicial && !filtros.situacaoCadastro) {
              const filtrosComSituacao = { ...filtros, situacaoCadastro: "ATIVO" };
              // Atualiza o estado dos filtros para que o dropdown mostre "ATIVO"
              setFiltros(filtrosComSituacao);
              setBuscaInicial(false);
              
              // prepara query string sanetizada para backend (documento sem pontuação)
              const filtrosSanitizados = { ...filtrosComSituacao, documento: filtrosComSituacao.documento.replace(/\D/g, '') };
              const sanitizedQueryString = FiltroUtils.applyPageFilter(page, pageSize, filtrosSanitizados);
              await fetchClientes(sanitizedQueryString);
            } else {
              // Para buscas subsequentes, usar os filtros exatamente como o usuário definiu
              // prepara query string sanetizada para backend (documento sem pontuação)
              const filtrosSanitizados = { ...filtros, documento: filtros.documento.replace(/\D/g, '') };
              
              // atualiza URL com filtros originais
              aplicarFiltros(page);
              
              const sanitizedQueryString = FiltroUtils.applyPageFilter(page, pageSize, filtrosSanitizados);
              await fetchClientes(sanitizedQueryString);
            }
          };
          
          if (filtrarRef.current !== filtrar) {
            filtrarRef.current = filtrar;
          }
          
          if (currentPageRef.current !== currentPage) {
            currentPageRef.current = currentPage;
            filtrar(currentPage);
          }

          // Sempre que pesquisar, volta para página 0 e filtra
          const pesquisar = async () => {
            setBuscaInicial(false); // Marcar que não é mais busca inicial
            irParaPagina(0);
            await filtrar(0);
          };

          // Função customizada para limpar filtros
          const limparFiltrosCustom = () => {
            setBuscaInicial(false); // Marcar que não é mais busca inicial
            limparFiltros();
          };

          const handleEditar = cliente => {
            if (cliente.clienteDTO.id) {
              navigate(getEditarPath(APP_ROUTES.CLIENTE_GERAL_EDITAR, cliente.clienteDTO.id));
            }
          };

          const handleCriarCliente = () => {
            navigate(APP_ROUTES.CLIENTE_CADASTRO);
          };

          return (
            <div>
              {carregamentoGeral() && <Carregamento />}
              
              <CabecalhoPadrao
                titulo={Mensagens.CLIENTE.LISTAGEM.TITULO}
                permissao={PERMISSOES.CLIENTE_CADASTRAR}
                onClick={handleCriarCliente}
                gerarCsv={() => gerarCsvCliente(filtros)}
                gerarCsvAdicional={() => gerarCsvSistema(filtros)}
                textoCsv={Mensagens.CLIENTE.LISTAGEM.CSV_CLIENTE}
                textoCsvAdicional={Mensagens.CLIENTE.LISTAGEM.CSV_SISTEMA}
                textoTooltip={Mensagens.CLIENTE.LISTAGEM.CSV_CLIENTE_TOOLTIP}
                textoTooltipAdicional={Mensagens.CLIENTE.LISTAGEM.CSV_SISTEMA_TOOLTIP}
                permissaoCsv={PERMISSOES.CLIENTE_LISTAR}
                permissaoCsvAdicional={PERMISSOES.SISTEMA_LISTAR}
              />
              
              <FiltroPadrao
                filtrar={pesquisar}
                limparFiltros={limparFiltrosCustom}
                expansivo={true}
                expandedChildren={
                  <>
                    <DropdownPadrao
                      label={'Plano'}
                      showFilter={true}
                      options={planos}
                      value={filtros.idPlano}
                      name="idPlano"
                      onChange={e => setFiltros({ ...filtros, idPlano: e.target.value })}
                    />
                    <InputPadrao
                      label={'Unidade'}
                      placeholder={'Digite a unidade'}
                      value={filtros.unidade}
                      name="unidade"
                      onChange={e => setFiltros({ ...filtros, unidade: e.target.value })}
                    />
                  </>
                }
              >
                <DropdownPadrao
                  label={Mensagens.CLIENTE.LISTAGEM.FILTRO_EMPRESA}
                  showFilter={true}
                  options={empresas}
                  value={filtros.idEmpresa}
                  name="idEmpresa"
                  exibirSe={isSuperAdmin()}
                  onChange={e => setFiltros({ ...filtros, idEmpresa: e.target.value })}
                />
                <InputPadrao
                  label={'Razão Social'}
                  placeholder={'Digite a razão social'}
                  value={filtros.razaoSocial}
                  name="razaoSocial"
                  onChange={e => setFiltros({ ...filtros, razaoSocial: e.target.value })}
                />
                <DropdownPadrao
                  label={'Situação Cadastro'}
                  showFilter={true}
                  options={OPCOES_SITUACAO}
                  value={filtros.situacaoCadastro}
                  name="situacaoCadastro"
                  onChange={e => setFiltros({ ...filtros, situacaoCadastro: e.target.value })}
                />
                <InputPadrao
                  label={Mensagens.EMPRESA.LISTAGEM.FILTRO_DOCUMENTO}
                  placeholder={Mensagens.EMPRESA.LISTAGEM.FILTRO_DOCUMENTO_PLACEHOLDER}
                  value={filtros.documento}
                  name="documento"
                  onChange={e => setFiltros({ ...filtros, documento: e.target.value })}
                />
              </FiltroPadrao>
              
              <TabelaPadrao
                expansivo={item => item.sistemas && item.sistemas.length > 0}
                renderExpansao={item => (
                  <div className="tabela-expansao-scroll">
                    <ListagemInfoLicenca
                      exibeEditar={false}
                      exibeEditarPadrao={validarPermissoes(PERMISSOES.SISTEMA_EDITAR)}
                      informacoesLicenca={item.sistemas || []}
                      onClickEditar={licenca => handleEditarLicenca(licenca, item)}
                    />
                  </div>
                )}
                dados={clientes}
                colunas={colunas}
                totalItems={totalClientes}
                paginaAtual={currentPage}
                tamanhoPagina={pageSize}
                carregando={carregando}
                onEditar={handleEditar}
                onProximaPagina={proximaPagina}
                onPaginaAnterior={paginaAnterior}
                onIrParaPagina={irParaPagina}
                colunasFixas={colunasFixas}
                breakpoints={BREAKPOINTS_PADRAO}
                permissaoEditar={PERMISSOES.CLIENTE_EDITAR}
                gruposColunas={[{ titulo: 'Licenças', indices: [4, 5] }]}
                colunasPermissao={colunasPermissao}
              />
            </div>
          );
        }}
      </FiltroURLWrapper>
    );
};
 
export default ListagemCliente;